import {Suspense} from "react";

import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {ErrorFallback} from "@/lib/handlers/ErrorFallback.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {RTAContent} from "@/pages/checks/rta/RTAContent.tsx";

export const RTAPage = () => (
  <Suspense>
    <UpErrorBoundary
      fallback={
        <ContentContainer title="Real-Time Analysis">
          <ErrorFallback />
        </ContentContainer>
      }
    >
      <RTAContent />
    </UpErrorBoundary>
  </Suspense>
);
